import {
  funcScrollControl,
  funcLoad,
  topMain,
  comMain,
} from './index';

const funcEntry = (() => {


  funcScrollControl.noScroll();


  if (document.querySelector("body#pageTop") !== null) {

    let sW = window.innerWidth;
    let sec = document.querySelector('#jsSecMain');
    let wrap = sec.querySelector('.js-main-wrap');
    let box = wrap.querySelector('.js-video-box');
    let video
    if (sW > 768) {
      video = box.querySelector('.js-video-pc');
    } else {
      video = box.querySelector('.js-video-sp');
    }
    video.load()

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        funcLoad()
        topMain()
      }, 250);
    });

  } else {

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        funcLoad()
        comMain()
      }, 250);
    });

  }


})();
export default funcEntry;